import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UsersService} from '../../../users/users.service';
import {SurveyService} from '../../surveys.service';
import {SurveyMailListModel} from '../../../../models/survey/survey.model';
import {FormBuilder, Validators} from '@angular/forms';
import {COMMON_LENGTH} from '../../../../shared/constants/input.constants';
@Component({
  selector: 'app-mail-list-tab',
  templateUrl: './mail-list-tab.component.html',
  styleUrls: ['./mail-list-tab.component.less']
})
export class MailListTabComponent implements OnInit {

  @Input() surveyId: number;
  showLoader = false;

  editForm = this.fb.group({
    mailSync: [false],
    audience: [null, [Validators.maxLength(COMMON_LENGTH.MAX_LENGTH_255)]],
    emailQuestion: [null],
    nameQuestion: [null],
  });

  mailchimpSyncStartTime: any;
  mailchimpSyncEndTime: any;
  mailchimpSyncError: string;
  mailChimpSuccessCount: any;
  mailChimpSkippedCount: any;
  disabledSync = true;
  isSaving = false;
  oldSurveyData: any;
  showSaveFirst = false;
  showSyncCouldNotStart = false;
  showSyncContinue = false;
  syncSuccessfully = false;
  syncError = false;

  constructor(private userService: UsersService,
              private surveyService: SurveyService,
              protected fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.surveyService.getSurveyMailList(this.surveyId)
      .subscribe(res => {
        this.oldSurveyData = res;
        this.updateForm(res);
      });
  }

  displayExpr(s) {
    return `${s.firstName} ${s.lastName}`;
  }

  save() {
    this.processSave(null);
  }

  processSave(callback?: Function): void {
    this.showLoader = true;
    this.isSaving = true;
    const surveyMailListModel = new SurveyMailListModel();
    surveyMailListModel.id = this.surveyId;
    surveyMailListModel.syncToMailchimp = this.editForm.get(['mailSync']).value;
    surveyMailListModel.mailchimpAudience = this.editForm.get(['audience']).value;
    surveyMailListModel.questionNumberForEmail = this.editForm.get(['emailQuestion']).value;
    surveyMailListModel.questionNumberForName = this.editForm.get(['nameQuestion']).value;

    this.surveyService.updateSurveyMailList(surveyMailListModel)
      .subscribe(res => {
        this.oldSurveyData = res;
        this.showLoader = false;
        this.isSaving = false;
        if (callback) {
            callback();
        }
      }, _ => {
        this.showLoader = false;
        this.isSaving = false;
      });
  }

  deleteData(checked: boolean): void {

    if(!checked) {
      this.editForm.controls['audience'].setValue(null);
      this.editForm.controls['emailQuestion'].setValue(null);
      this.editForm.controls['nameQuestion'].setValue(null);

      this.clearValidators();
      this.disabledSync = true;
    } else {
      this.disabledSync = false;
      this.setValidators();
    }
  }

  isEnableRunNow(): boolean {

    const syncToMailchimp = this.editForm.get(['mailSync']).value;
    const mailchimpAudience = this.editForm.get(['audience']).value;
    const questionNumberForEmail = this.editForm.get(['emailQuestion']).value;
    const questionNumberForName = this.editForm.get(['nameQuestion']).value;

    return syncToMailchimp === true && mailchimpAudience && questionNumberForEmail && questionNumberForName;
  }

  onRunNow(): void {
    this.surveyService.getSurveyMailList(this.surveyId)
    .subscribe(res => {
      if (res.isMailChimpSyncRunning === true) {
        this.showSyncCouldNotStart = true;
      } else {
        if (this.isDataChanged()) {
            this.showSaveFirst = true;
        } else {
            this.showSyncContinue = true;
        }
      }
    });
  }

  runNow(): void {
    this.showLoader = true;
    this.surveyService.mailListRunNow(this.surveyId)
    .subscribe(res => {
      this.showLoader = false;
      this.oldSurveyData = res;
	  if (res.mailchimpSyncStartTime) {
		var date = new Date(res.mailchimpSyncStartTime + ' UTC');
		res.mailchimpSyncStartTime = date.toLocaleString();
	  }
	  if (res.mailchimpSyncEndTime) {
        var date = new Date(res.mailchimpSyncEndTime + ' UTC');
        res.mailchimpSyncEndTime = date.toLocaleString();
      }
      this.mailchimpSyncStartTime = res.mailchimpSyncStartTime;
      this.mailchimpSyncEndTime = res.mailchimpSyncEndTime;
      this.mailChimpSuccessCount = res.mailChimpSuccessCount;
      this.mailChimpSkippedCount = res.mailChimpSkippedCount;
      this.mailchimpSyncError = res.mailchimpSyncError;
      if (res.mailchimpSyncError === '') {
          this.syncSuccessfully = true;
      } else {
        this.syncError = true;
      }
    }, _ => {
      this.showLoader = false;
      this.syncError = true;
    });
  }

  saveSurveyFirst() {
    this.showSaveFirst = false;
    this.processSave(() => {
        this.runNow();
    });
  }

  get isValidForm(): boolean {
    return this.editForm.valid;
  }

  protected updateForm(survey: any): void {


    if(survey.syncToMailchimp) {
      this.setValidators();
    }
    
    if (survey.mailchimpSyncStartTime) {
      var date = new Date(survey.mailchimpSyncStartTime + ' UTC');
      survey.mailchimpSyncStartTime = date.toLocaleString();
    }
    if (survey.mailchimpSyncEndTime) {
      var date = new Date(survey.mailchimpSyncEndTime + ' UTC');
      survey.mailchimpSyncEndTime = date.toLocaleString();
    }

    this.editForm.patchValue({
      mailSync: survey.syncToMailchimp,
      audience: survey.mailchimpAudience,
      emailQuestion: survey.questionNumberForEmail,
      nameQuestion: survey.questionNumberForName,
    });
    this.mailchimpSyncStartTime = survey.mailchimpSyncStartTime;
    this.mailchimpSyncEndTime = survey.mailchimpSyncEndTime;
    this.mailChimpSuccessCount = survey.mailChimpSuccessCount;
    this.mailChimpSkippedCount = survey.mailChimpSkippedCount;
    this.mailchimpSyncError = survey.mailchimpSyncError;
    this.disabledSync = !survey.syncToMailchimp;
  }

  private clearValidators(): void {
    this.editForm.controls['audience'].clearValidators();
    this.editForm.controls['audience'].updateValueAndValidity();
    this.editForm.controls['emailQuestion'].clearValidators();
    this.editForm.controls['emailQuestion'].updateValueAndValidity();
    this.editForm.controls['nameQuestion'].clearValidators();
    this.editForm.controls['nameQuestion'].updateValueAndValidity();
  }

  private setValidators() : void {
    this.editForm.controls['audience'].setValidators([Validators.required, Validators.maxLength(COMMON_LENGTH.MAX_LENGTH_255)]);
    this.editForm.controls['audience'].updateValueAndValidity();
    this.editForm.controls['emailQuestion'].setValidators([Validators.required]);
    this.editForm.controls['emailQuestion'].updateValueAndValidity();
    this.editForm.controls['nameQuestion'].setValidators([Validators.required]);
    this.editForm.controls['nameQuestion'].updateValueAndValidity();
  }

  private isDataChanged() {
    const mailchimpAudience = this.editForm.get(['audience']).value;
    const questionNumberForEmail = this.editForm.get(['emailQuestion']).value;
    const questionNumberForName = this.editForm.get(['nameQuestion']).value;
    return String(this.oldSurveyData.mailchimpAudience) !== String(mailchimpAudience) || 
        String(this.oldSurveyData.questionNumberForEmail) !== String(questionNumberForEmail) || 
            String(this.oldSurveyData.questionNumberForName) !== String(questionNumberForName);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/mail-list-tab/mail-list-tab.component.ts